const messages = {
  map_toggleTraffic_show: "Mostrar trânsito",
  map_toggleTraffic_hide: "Ocultar trânsito"
};

export default messages;
